export default __webpack_public_path__ + "static/media/039-teddy bear.b4f179c6.svg";